import { useReducer, createContext } from "react";
import { deleteJSON, getJSON, patchJSON, postJSON } from "utils/axios";
import { toast } from "react-hot-toast";

const initialState = {
  categories: null,
  isFetchingCategories: false,
  merchants: null,
  isFetchingMerchants: false,
  bankAccounts: null,
  isFetchingBankAccounts: false,
  isCreatingBankAccount: false,
  isEditingBankAccount: false,
  isDeletingBankAccount: false,
  selfTransferAccounts: null,
  isFetchingSelfTransferAccounts: false,
  isCreatingSelfTransferAccount: false,
  isEditingSelfTransferAccount: false,
  isDeletingSelfTransferAccount: false,
  isCreatingMerchant: false,
  isEditingMerchant: false,
  isDeletingMerchant: false,
  isCreatingCategory: false,
  isCreatingSubCategory: false,
  isEditingSubCategory: false,
  isDeletingParentCategory: false,
  isDeletingSubCategory: false,
  incomeCategories: null,
  isFetchingIncomeCategories: false,
  isCreatingIncomeCategory: false,
  isEditingIncomeCategory: false,
  isDeletingIncomeCategory: false,
};

export const CommonStateContext = createContext();
export const CommonDispatchContext = createContext();

const ACTION_TYPES = {
  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE: "GET_CATEGORIES_FAILURE",
  GET_MERCHANTS_REQUEST: "GET_MERCHANTS_REQUEST",
  GET_MERCHANTS_SUCCESS: "GET_MERCHANTS_SUCCESS",
  GET_MERCHANTS_FAILURE: "GET_MERCHANTS_FAILURE",
  CREATE_CATEGORY_REQUEST: "CREATE_CATEGORY_REQUEST",
  CREATE_CATEGORY_SUCCESS: "CREATE_CATEGORY_SUCCESS",
  CREATE_CATEGORY_FAILURE: "CREATE_CATEGORY_FAILURE",
  CREATE_SUB_CATEGORY_REQUEST: "CREATE_SUB_CATEGORY_REQUEST",
  CREATE_SUB_CATEGORY_SUCCESS: "CREATE_SUB_CATEGORY_SUCCESS",
  CREATE_SUB_CATEGORY_FAILURE: "CREATE_SUB_CATEGORY_FAILURE",
  EDIT_SUB_CATEGORY_REQUEST: "EDIT_SUB_CATEGORY_REQUEST",
  EDIT_SUB_CATEGORY_SUCCESS: "EDIT_SUB_CATEGORY_SUCCESS",
  EDIT_SUB_CATEGORY_FAILURE: "EDIT_SUB_CATEGORY_FAILURE",
  DELETE_PARENT_CATEGORY_REQUEST: "DELETE_PARENT_CATEGORY_REQUEST",
  DELETE_PARENT_CATEGORY_SUCCESS: "DELETE_PARENT_CATEGORY_SUCCESS",
  DELETE_PARENT_CATEGORY_FAILURE: "DELETE_PARENT_CATEGORY_FAILURE",
  DELETE_SUB_CATEGORY_REQUEST: "DELETE_SUB_CATEGORY_REQUEST",
  DELETE_SUB_CATEGORY_SUCCESS: "DELETE_SUB_CATEGORY_SUCCESS",
  DELETE_SUB_CATEGORY_FAILURE: "DELETE_SUB_CATEGORY_FAILURE",
  CREATE_MERCHANT_REQUEST: "CREATE_MERCHANT_REQUEST",
  CREATE_MERCHANT_SUCCESS: "CREATE_MERCHANT_SUCCESS",
  CREATE_MERCHANT_FAILURE: "CREATE_MERCHANT_FAILURE",
  EDIT_MERCHANT_REQUEST: "EDIT_MERCHANT_REQUEST",
  EDIT_MERCHANT_SUCCESS: "EDIT_MERCHANT_SUCCESS",
  EDIT_MERCHANT_FAILURE: "EDIT_MERCHANT_FAILURE",
  DELETE_MERCHANT_REQUEST: "DELETE_MERCHANT_REQUEST",
  DELETE_MERCHANT_SUCCESS: "DELETE_MERCHANT_SUCCESS",
  DELETE_MERCHANT_FAILURE: "DELETE_MERCHANT_FAILURE",
  CREATE_SUB_CATEGORY_TAG_REQUEST: "CREATE_SUB_CATEGORY_TAG_REQUEST",
  CREATE_SUB_CATEGORY_TAG_SUCCESS: "CREATE_SUB_CATEGORY_TAG_SUCCESS",
  CREATE_SUB_CATEGORY_TAG_FAILURE: "CREATE_SUB_CATEGORY_TAG_FAILURE",
  DELETE_SUB_CATEGORY_TAG_REQUEST: "DELETE_SUB_CATEGORY_TAG_REQUEST",
  DELETE_SUB_CATEGORY_TAG_SUCCESS: "DELETE_SUB_CATEGORY_TAG_SUCCESS",
  DELETE_SUB_CATEGORY_TAG_FAILURE: "DELETE_SUB_CATEGORY_TAG_FAILURE",
  GET_BANK_ACCOUNTS_REQUEST: "GET_BANK_ACCOUNTS_REQUEST",
  GET_BANK_ACCOUNTS_SUCCESS: "GET_BANK_ACCOUNTS_SUCCESS",
  GET_BANK_ACCOUNTS_FAILURE: "GET_BANK_ACCOUNTS_FAILURE",
  CREATE_BANK_ACCOUNT_REQUEST: "CREATE_BANK_ACCOUNT_REQUEST",
  CREATE_BANK_ACCOUNT_SUCCESS: "CREATE_BANK_ACCOUNT_SUCCESS",
  CREATE_BANK_ACCOUNT_FAILURE: "CREATE_BANK_ACCOUNT_FAILURE",
  EDIT_BANK_ACCOUNT_REQUEST: "EDIT_BANK_ACCOUNT_REQUEST",
  EDIT_BANK_ACCOUNT_SUCCESS: "EDIT_BANK_ACCOUNT_SUCCESS",
  EDIT_BANK_ACCOUNT_FAILURE: "EDIT_BANK_ACCOUNT_FAILURE",
  DELETE_BANK_ACCOUNT_REQUEST: "DELETE_BANK_ACCOUNT_REQUEST",
  DELETE_BANK_ACCOUNT_SUCCESS: "DELETE_BANK_ACCOUNT_SUCCESS",
  DELETE_BANK_ACCOUNT_FAILURE: "DELETE_BANK_ACCOUNT_FAILURE",
  GET_SELF_TRANSFER_ACCOUNTS_REQUEST: "GET_SELF_TRANSFER_ACCOUNTS_REQUEST",
  GET_SELF_TRANSFER_ACCOUNTS_SUCCESS: "GET_SELF_TRANSFER_ACCOUNTS_SUCCESS",
  GET_SELF_TRANSFER_ACCOUNTS_FAILURE: "GET_SELF_TRANSFER_ACCOUNTS_FAILURE",
  CREATE_SELF_TRANSFER_ACCOUNT_REQUEST: "CREATE_SELF_TRANSFER_ACCOUNT_REQUEST",
  CREATE_SELF_TRANSFER_ACCOUNT_SUCCESS: "CREATE_SELF_TRANSFER_ACCOUNT_SUCCESS",
  CREATE_SELF_TRANSFER_ACCOUNT_FAILURE: "CREATE_SELF_TRANSFER_ACCOUNT_FAILURE",
  EDIT_SELF_TRANSFER_ACCOUNT_REQUEST: "EDIT_SELF_TRANSFER_ACCOUNT_REQUEST",
  EDIT_SELF_TRANSFER_ACCOUNT_SUCCESS: "EDIT_SELF_TRANSFER_ACCOUNT_SUCCESS",
  EDIT_SELF_TRANSFER_ACCOUNT_FAILURE: "EDIT_SELF_TRANSFER_ACCOUNT_FAILURE",
  DELETE_SELF_TRANSFER_ACCOUNT_REQUEST: "DELETE_SELF_TRANSFER_ACCOUNT_REQUEST",
  DELETE_SELF_TRANSFER_ACCOUNT_SUCCESS: "DELETE_SELF_TRANSFER_ACCOUNT_SUCCESS",
  DELETE_SELF_TRANSFER_ACCOUNT_FAILURE: "DELETE_SELF_TRANSFER_ACCOUNT_FAILURE",
  GET_INCOME_CATEGORIES_REQUEST: "GET_INCOME_CATEGORIES_REQUEST",
  GET_INCOME_CATEGORIES_SUCCESS: "GET_INCOME_CATEGORIES_SUCCESS",
  GET_INCOME_CATEGORIES_FAILURE: "GET_INCOME_CATEGORIES_FAILURE",
  CREATE_INCOME_CATEGORY_REQUEST: "CREATE_INCOME_CATEGORY_REQUEST",
  CREATE_INCOME_CATEGORY_SUCCESS: "CREATE_INCOME_CATEGORY_SUCCESS",
  CREATE_INCOME_CATEGORY_FAILURE: "CREATE_INCOME_CATEGORY_FAILURE",
  EDIT_INCOME_CATEGORY_REQUEST: "EDIT_INCOME_CATEGORY_REQUEST",
  EDIT_INCOME_CATEGORY_SUCCESS: "EDIT_INCOME_CATEGORY_SUCCESS",
  EDIT_INCOME_CATEGORY_FAILURE: "EDIT_INCOME_CATEGORY_FAILURE",
  CREATE_INCOME_CATEGORY_TAG_REQUEST: "CREATE_INCOME_CATEGORY_TAG_REQUEST",
  CREATE_INCOME_CATEGORY_TAG_SUCCESS: "CREATE_INCOME_CATEGORY_TAG_SUCCESS",
  CREATE_INCOME_CATEGORY_TAG_FAILURE: "CREATE_INCOME_CATEGORY_TAG_FAILURE",
  DELETE_INCOME_CATEGORY_TAG_REQUEST: "DELETE_INCOME_CATEGORY_TAG_REQUEST",
  DELETE_INCOME_CATEGORY_TAG_SUCCESS: "DELETE_INCOME_CATEGORY_TAG_SUCCESS",
  DELETE_INCOME_CATEGORY_TAG_FAILURE: "DELETE_INCOME_CATEGORY_TAG_FAILURE",
  DELETE_INCOME_CATEGORY_REQUEST: "DELETE_INCOME_CATEGORY_REQUEST",
  DELETE_INCOME_CATEGORY_SUCCESS: "DELETE_INCOME_CATEGORY_SUCCESS",
  DELETE_INCOME_CATEGORY_FAILURE: "DELETE_INCOME_CATEGORY_FAILURE",
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetchingCategories: true,
      };
    case ACTION_TYPES.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetchingCategories: false,
        categories: action.payload.categories,
      };
    case ACTION_TYPES.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetchingCategories: false,
        categories: [],
      };
    case ACTION_TYPES.GET_MERCHANTS_REQUEST:
      return {
        ...state,
        isFetchingMerchants: true,
      };
    case ACTION_TYPES.GET_MERCHANTS_SUCCESS:
      return {
        ...state,
        isFetchingMerchants: false,
        merchants: action.payload.merchants,
      };
    case ACTION_TYPES.GET_MERCHANTS_FAILURE:
      return {
        ...state,
        isFetchingMerchants: false,
        merchants: [],
      };
    case ACTION_TYPES.CREATE_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isCreatingSubCategory: true,
      };
    case ACTION_TYPES.CREATE_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isCreatingSubCategory: false,
        categories: [...state?.categories].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: [
                ...c?.options,
                {
                  label: action.payload.newSubCategory.name,
                  value: action.payload.newSubCategory.id,
                  icon: action.payload.newSubCategory.icon,
                },
              ],
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.CREATE_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        isCreatingSubCategory: false,
      };
    case ACTION_TYPES.CREATE_CATEGORY_REQUEST:
      return {
        ...state,
        isCreatingCategory: true,
      };
    case ACTION_TYPES.CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        isCreatingCategory: false,
        categories: [
          ...state?.categories,
          {
            label: action.payload.newCategory.name,
            id: action.payload.newCategory.id,
            reserved: action.payload.newCategory.reserved,
            isInvestment: action.payload.newCategory.is_investment,
            options: [],
          },
        ],
      };
    case ACTION_TYPES.CREATE_CATEGORY_FAILURE:
      return {
        ...state,
        isCreatingCategory: false,
      };
    case ACTION_TYPES.EDIT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isEditingSubCategory: true,
      };
    case ACTION_TYPES.EDIT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isEditingSubCategory: false,
        categories: [...state?.categories].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: c.options?.map((option) => {
                if (option.value === Number(action.payload.subCategoryId)) {
                  return action.payload.updatedSubCategory;
                }
                return option;
              }),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.EDIT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        isEditingSubCategory: false,
      };
    case ACTION_TYPES.DELETE_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isDeletingSubCategory: true,
      };
    case ACTION_TYPES.DELETE_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isDeletingSubCategory: false,
        categories: [...state?.categories].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: c.options?.filter(
                (f) => f.value !== Number(action.payload.subCategoryId)
              ),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.DELETE_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        isDeletingSubCategory: false,
      };
    case ACTION_TYPES.CREATE_MERCHANT_REQUEST:
      return {
        ...state,
        isCreatingMerchant: true,
      };
    case ACTION_TYPES.CREATE_MERCHANT_SUCCESS:
      const merchant = {
        label: action.payload.newMerchant?.name,
        value: action.payload.newMerchant?.id,
      };
      return {
        ...state,
        isCreatingMerchant: false,
        merchants: [...state.merchants, merchant],
      };
    case ACTION_TYPES.CREATE_MERCHANT_FAILURE:
      return {
        ...state,
        isCreatingMerchant: false,
      };
    case ACTION_TYPES.EDIT_MERCHANT_REQUEST:
      return {
        ...state,
        isEditingMerchant: true,
      };
    case ACTION_TYPES.EDIT_MERCHANT_SUCCESS:
      return {
        ...state,
        isEditingMerchant: false,
        merchants: [...state.merchants].map((merchant) => {
          if (merchant.value === Number(action.payload.merchantId)) {
            return {
              label: action.payload.updatedMerchant?.name,
              value: action.payload.updatedMerchant?.id,
            };
          }
          return merchant;
        }),
      };
    case ACTION_TYPES.EDIT_MERCHANT_FAILURE:
      return {
        ...state,
        isEditingMerchant: false,
      };
    case ACTION_TYPES.DELETE_MERCHANT_REQUEST:
      return {
        ...state,
        isDeletingMerchant: true,
      };
    case ACTION_TYPES.DELETE_MERCHANT_SUCCESS:
      return {
        ...state,
        isDeletingMerchant: false,
        merchants: [...state.merchants].filter(
          (merchant) => merchant?.value !== Number(action.payload.merchantId)
        ),
      };
    case ACTION_TYPES.DELETE_MERCHANT_FAILURE:
      return {
        ...state,
        isDeletingMerchant: false,
      };

    case ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_REQUEST:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  const tempTag = {
                    id: action.payload.tempId,
                    name: action.payload.newTagName,
                    reserved: false,
                    isAdding: true,
                  };
                  return {
                    ...opt,
                    tags: [...(opt.tags ?? []), tempTag],
                  };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_SUCCESS:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  const tags = (opt.tags ?? []).map((tag) =>
                    tag.id === action.payload.tempId
                      ? action.payload.newTag
                      : tag
                  );
                  return { ...opt, tags };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_FAILURE:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  return {
                    ...opt,
                    tags: (opt.tags ?? []).filter(
                      (tag) => tag.id !== action.payload.tempId
                    ),
                  };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };

    case ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_REQUEST:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  return {
                    ...opt,
                    tags: (opt.tags ?? []).map((tag) =>
                      tag.id === action.payload.tagId
                        ? { ...tag, isDeleting: true }
                        : tag
                    ),
                  };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_SUCCESS:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  return {
                    ...opt,
                    tags: (opt.tags ?? []).filter(
                      (f) => f.id !== action.payload.tagId
                    ),
                  };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };
    case ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_FAILURE:
      return {
        ...state,
        categories: [...(state?.categories ?? [])].map((c) => {
          if (c.id === Number(action.payload.parentCategoryId)) {
            return {
              ...c,
              options: (c.options ?? []).map((opt) => {
                if (opt.value === action.payload.subCategoryId) {
                  return {
                    ...opt,
                    tags: (opt.tags ?? []).map((tag) =>
                      tag.id === action.payload.tagId
                        ? { ...tag, isDeleting: false }
                        : tag
                    ),
                  };
                }
                return opt;
              }),
            };
          }
          return c;
        }),
      };

    case ACTION_TYPES.GET_BANK_ACCOUNTS_REQUEST:
      return {
        ...state,
        isFetchingBankAccounts: true,
      };
    case ACTION_TYPES.GET_BANK_ACCOUNTS_SUCCESS:
      return {
        ...state,
        isFetchingBankAccounts: false,
        bankAccounts: action.payload.bankAccounts,
      };
    case ACTION_TYPES.GET_BANK_ACCOUNTS_FAILURE:
      return {
        ...state,
        isFetchingBankAccounts: false,
        bankAccounts: [],
      };

    case ACTION_TYPES.CREATE_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        isCreatingBankAccount: true,
      };
    case ACTION_TYPES.CREATE_BANK_ACCOUNT_SUCCESS:
      const label =
        action.payload.newBankAccount?.label ||
        `${action.payload.newBankAccount?.bank?.name}-${action.payload.newBankAccount?.last_4_digits}`;
      const bankAccount = {
        label: label,
        value: action.payload.newBankAccount?.id,
        logo: action.payload.newBankAccount?.bank?.logo,
        accountType: action.payload.newBankAccount.account_type,
      };
      return {
        ...state,
        isCreatingBankAccount: false,
        bankAccounts: [...state.bankAccounts, bankAccount],
      };
    case ACTION_TYPES.CREATE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        isCreatingBankAccount: false,
      };
    case ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_REQUEST:
      return {
        ...state,
        isFetchingSelfTransferAccounts: true,
      };
    case ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_SUCCESS:
      return {
        ...state,
        isFetchingSelfTransferAccounts: false,
        selfTransferAccounts: action.payload.selfTransferAccounts,
      };
    case ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_FAILURE:
      return {
        ...state,
        isFetchingSelfTransferAccounts: false,
      };
    case ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_REQUEST:
      return {
        ...state,
        isCreatingSelfTransferAccount: true,
      };
    case ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isCreatingSelfTransferAccount: false,
        selfTransferAccounts: [
          ...state.selfTransferAccounts,
          action.payload.newAccount,
        ],
      };
    case ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_FAILURE:
      return {
        ...state,
        isCreatingSelfTransferAccount: false,
      };
    case ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_REQUEST:
      return {
        ...state,
        isEditingSelfTransferAccount: true,
      };
    case ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isEditingSelfTransferAccount: false,
        selfTransferAccounts: [...state.selfTransferAccounts].map((account) => {
          if (account.id === Number(action.payload.accountId)) {
            return {
              ...action.payload.updatedSelfTransferAccount,
            };
          }
          return account;
        }),
      };
    case ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_FAILURE:
      return {
        ...state,
        isEditingSelfTransferAccount: false,
      };
    case ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_REQUEST:
      return {
        ...state,
        isDeletingSelfTransferAccount: true,
      };
    case ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isDeletingSelfTransferAccount: false,
        selfTransferAccounts: [...state.selfTransferAccounts].filter(
          (account) => {
            return account.id !== Number(action.payload.accountId);
          }
        ),
      };
    case ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_FAILURE:
      return {
        ...state,
        isDeletingSelfTransferAccount: false,
      };
    case ACTION_TYPES.EDIT_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        isEditingBankAccount: true,
      };
    case ACTION_TYPES.EDIT_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        isEditingBankAccount: false,
        bankAccounts: [...state.bankAccounts].map((bankAccount) => {
          if (bankAccount.value === Number(action.payload.bankAccountId)) {
            return {
              label: action.payload.updatedBankAccount?.label,
              value: action.payload.updatedBankAccount?.id,
              logo: action.payload.updatedBankAccount?.bank?.logo,
              accountType: action.payload.updatedBankAccount?.account_type,
            };
          }
          return bankAccount;
        }),
      };
    case ACTION_TYPES.EDIT_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        isEditingBankAccount: false,
      };
    case ACTION_TYPES.DELETE_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        isDeletingBankAccount: true,
      };
    case ACTION_TYPES.DELETE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        isDeletingBankAccount: false,
        bankAccounts: [...state.bankAccounts].filter(
          (bankAccount) =>
            bankAccount?.value !== Number(action.payload.bankAccountId)
        ),
      };
    case ACTION_TYPES.DELETE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        isDeletingBankAccount: false,
      };

    case ACTION_TYPES.GET_INCOME_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetchingIncomeCategories: true,
      };
    case ACTION_TYPES.GET_INCOME_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetchingIncomeCategories: false,
        incomeCategories: action.payload.incomeCategories,
      };
    case ACTION_TYPES.GET_INCOME_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetchingIncomeCategories: false,
        incomeCategories: [],
      };

    case ACTION_TYPES.CREATE_INCOME_CATEGORY_REQUEST:
      return {
        ...state,
        isCreatingIncomeCategory: true,
      };
    case ACTION_TYPES.CREATE_INCOME_CATEGORY_SUCCESS:
      return {
        ...state,
        isCreatingIncomeCategory: false,
        incomeCategories: [
          ...(state?.incomeCategories ?? []),
          {
            label: action.payload.newIncomeCategory.name,
            id: action.payload.newIncomeCategory.id,
            reserved: action.payload.newIncomeCategory.reserved ?? false,
            icon: action.payload.newIncomeCategory.icon ?? false,
            options: [],
          },
        ],
      };
    case ACTION_TYPES.CREATE_INCOME_CATEGORY_FAILURE:
      return {
        ...state,
        isCreatingIncomeCategory: false,
      };

    case ACTION_TYPES.EDIT_INCOME_CATEGORY_REQUEST:
      return {
        ...state,
        isEditingIncomeCategory: true,
      };
    case ACTION_TYPES.EDIT_INCOME_CATEGORY_SUCCESS:
      return {
        ...state,
        isEditingIncomeCategory: false,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) =>
          category.id === Number(action.payload.incomeId)
            ? {
                ...category,
                label: action.payload.updatedIncomeCategory.name,
                icon: action.payload.updatedIncomeCategory.icon ?? category.icon,
              }
            : category
        ),
      };
    case ACTION_TYPES.EDIT_INCOME_CATEGORY_FAILURE:
      return {
        ...state,
        isEditingIncomeCategory: false,
      };

    case ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_REQUEST:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            const tempTag = {
              id: action.payload.tempId,
              name: action.payload.newTagName,
              reserved: false,
              isAdding: true,
            };
            return {
              ...category,
              tags: [...(category.tags ?? []), tempTag],
            };
          }
          return category;
        }),
      };
    case ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_SUCCESS:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            const newTag = {
              name: action.payload.newTag.name,
              id: action.payload.newTag.id,
              reserved: action.payload.newTag.reserved ?? false,
            };
            const tags = (category.tags ?? []).map((tag) =>
              tag.id === action.payload.tempId ? newTag : tag
            );
            return { ...category, tags };
          }
          return category;
        }),
      };
    case ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_FAILURE:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            return {
              ...category,
              tags: (category.tags ?? []).filter(
                (tag) => tag.id !== action.payload.tempId
              ),
            };
          }
          return category;
        }),
      };

    case ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_REQUEST:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            return {
              ...category,
              tags: (category.tags ?? []).map((tag) =>
                tag.id === action.payload.tagId
                  ? { ...tag, isDeleting: true }
                  : tag
              ),
            };
          }
          return category;
        }),
      };
    case ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_SUCCESS:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            return {
              ...category,
              tags: (category.tags ?? []).filter(
                (tag) => tag.id !== action.payload.tagId
              ),
            };
          }
          return category;
        }),
      };
    case ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_FAILURE:
      return {
        ...state,
        incomeCategories: [...(state?.incomeCategories ?? [])].map((category) => {
          if (category.id === Number(action.payload.incomeId)) {
            return {
              ...category,
              tags: (category.tags ?? []).map((tag) =>
                tag.id === action.payload.tagId
                  ? { ...tag, isDeleting: false }
                  : tag
              ),
            };
          }
          return category;
        }),
      };

    case ACTION_TYPES.DELETE_INCOME_CATEGORY_REQUEST:
      return {
        ...state,
        isDeletingIncomeCategory: true,
      };
    case ACTION_TYPES.DELETE_INCOME_CATEGORY_SUCCESS:
      return {
        ...state,
        isDeletingIncomeCategory: false,
        incomeCategories: (state?.incomeCategories ?? []).filter(
          (category) => category.id !== Number(action.payload.incomeId)
        ),
      };
    case ACTION_TYPES.DELETE_INCOME_CATEGORY_FAILURE:
      return {
        ...state,
        isDeletingIncomeCategory: false,
      };

    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
};

export const getIncomeCategories = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_INCOME_CATEGORIES_REQUEST,
  });
  try {
    const response = await getJSON("/api/incomes");
    if (response?.data) {
      const incomeCategoriesData = response.data.map((category) => ({
        label: category.name,
        id: category.id,
        reserved: category.reserved,
        icon: category.icon,
        tags: category.tags?.map((s) => ({
          name: s.name,
          id: s.id,
          reserved: s.reserved || false,
        })) ?? [],
      }));
      return dispatch({
        type: ACTION_TYPES.GET_INCOME_CATEGORIES_SUCCESS,
        payload: {
          incomeCategories: incomeCategoriesData,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.GET_INCOME_CATEGORIES_FAILURE,
    });
  }
};

export const createIncomeCategory = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_INCOME_CATEGORY_REQUEST,
  });
  try {
    const body = {
      income: {
        name: values.name,
        icon: values.icon ?? "",
      },
    };
    const response = await postJSON("/api/incomes", body);
    if (response?.data) {
      toast.success("Income category created!");
      dispatch({
        type: ACTION_TYPES.CREATE_INCOME_CATEGORY_SUCCESS,
        payload: {
          newIncomeCategory: response.data,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    const message =
      error?.message ||
      "Sorry, unable to create income category, please retry!";
    toast.error(message);
    dispatch({
      type: ACTION_TYPES.CREATE_INCOME_CATEGORY_FAILURE,
    });
  }
};

export const editIncomeCategory = async (dispatch, incomeId, values) => {
  dispatch({
    type: ACTION_TYPES.EDIT_INCOME_CATEGORY_REQUEST,
  });
  try {
    const body = {
      income: {
        name: values.name,
        icon: values.icon ?? "",
      },
    };
    const response = await patchJSON(`/api/incomes/${incomeId}`, body);
    if (response?.data) {
      toast.success("Income category updated!");
      dispatch({
        type: ACTION_TYPES.EDIT_INCOME_CATEGORY_SUCCESS,
        payload: {
          incomeId,
          updatedIncomeCategory: response.data,
        },
      });
    }
  } catch (error) {
    const message =
      error?.message ||
      "Sorry, unable to update income category, please retry!";
    toast.error(message);
    dispatch({
      type: ACTION_TYPES.EDIT_INCOME_CATEGORY_FAILURE,
    });
  }
};

export const addIncomeCategoryTag = async (dispatch, incomeId, newTagName) => {
  const tempId = `temp-${Date.now()}`;
  dispatch({
    type: ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_REQUEST,
    payload: { incomeId, newTagName, tempId },
  });
  try {
    const body = {
      income_tag: {
        name: newTagName,
      },
    };
    const response = await postJSON(`/api/incomes/${incomeId}/tags`, body);
    if (response?.data) {
      toast.success(`New "${newTagName}" tag saved!`);
      return dispatch({
        type: ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_SUCCESS,
        payload: {
          incomeId,
          newTag: response.data,
          tempId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.CREATE_INCOME_CATEGORY_TAG_FAILURE,
      payload: { incomeId, tempId },
    });
    toast.error(error?.message || "Oops, tag creation failed!");
  }
};

export const getBankAccounts = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_BANK_ACCOUNTS_REQUEST,
  });
  try {
    const response = await getJSON("/api/bank_accounts");
    if (response?.data) {
      const banksData = response.data.map((item) => ({
        value: item?.id,
        label: `${item?.bank?.name}-${item?.last_4_digits}`,
        logo: item?.bank?.logo,
        accountType: item.account_type,
      }));
      return dispatch({
        type: ACTION_TYPES.GET_BANK_ACCOUNTS_SUCCESS,
        payload: {
          bankAccounts: banksData,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.GET_BANK_ACCOUNTS_FAILURE,
    });
  }
};

export const getSelfTransferAccounts = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_REQUEST,
  });
  try {
    const response = await getJSON("/api/self_transfers");
    if (response?.data) {
      const data = response.data;
      return dispatch({
        type: ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_SUCCESS,
        payload: {
          selfTransferAccounts: data,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.GET_SELF_TRANSFER_ACCOUNTS_FAILURE,
    });
  }
};

export const createSelfTransferAccount = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_REQUEST,
  });
  try {
    const response = await postJSON(`/api/self_transfers`, values);
    if (response?.data) {
      toast.success("Self Transfer Account created!");
      dispatch({
        type: ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_SUCCESS,
        payload: {
          newAccount: response.data,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    const message =
      error?.message ||
      "Sorry, unable to create self transfer account, please retry!";
    toast.error(message);
    dispatch({
      type: ACTION_TYPES.CREATE_SELF_TRANSFER_ACCOUNT_FAILURE,
    });
  }
};

export const editSelfTransferAccount = async (dispatch, accountId, values) => {
  dispatch({
    type: ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_REQUEST,
  });
  try {
    const response = await patchJSON(
      `/api/self_transfers/${accountId}`,
      values
    );
    if (response?.data) {
      toast.success("Self Transfer Account updated!");
      dispatch({
        type: ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_SUCCESS,
        payload: {
          updatedSelfTransferAccount: response.data,
          accountId,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.EDIT_SELF_TRANSFER_ACCOUNT_FAILURE,
    });
  }
};

export const deleteSelfTransferAccount = async (dispatch, accountId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/self_transfers/${accountId}`);
    if (response?.status === 204) {
      toast.success("Self Transfer Account deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_SUCCESS,
        payload: {
          accountId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_SELF_TRANSFER_ACCOUNT_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const createBankAccount = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_BANK_ACCOUNT_REQUEST,
  });
  try {
    const response = await postJSON(`/api/bank_accounts`, values);
    if (response?.data) {
      toast.success("Bank Account created!");
      dispatch({
        type: ACTION_TYPES.CREATE_BANK_ACCOUNT_SUCCESS,
        payload: {
          newBankAccount: response.data,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    const message =
      error?.message || "Sorry, unable to create bank account, please retry!";
    toast.error(message);
    dispatch({
      type: ACTION_TYPES.CREATE_BANK_ACCOUNT_FAILURE,
    });
  }
};

export const editBankAccount = async (dispatch, bankAccountId, values) => {
  dispatch({
    type: ACTION_TYPES.EDIT_BANK_ACCOUNT_REQUEST,
  });
  try {
    const response = await patchJSON(
      `/api/bank_accounts/${bankAccountId}`,
      values
    );
    if (response?.data) {
      toast.success("Bank Account updated!");
      dispatch({
        type: ACTION_TYPES.EDIT_BANK_ACCOUNT_SUCCESS,
        payload: {
          updatedBankAccount: response.data,
          bankAccountId,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.EDIT_BANK_ACCOUNT_FAILURE,
    });
  }
};

export const deleteBankAccount = async (dispatch, bankAccountId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_BANK_ACCOUNT_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/bank_accounts/${bankAccountId}`);
    if (response?.status === 204) {
      toast.success("Bank Account deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_BANK_ACCOUNT_SUCCESS,
        payload: {
          bankAccountId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_BANK_ACCOUNT_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const getMerchants = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_MERCHANTS_REQUEST,
  });
  try {
    const response = await getJSON("/api/merchants");
    if (response?.data) {
      const merchantData = response.data.map((merchant) => ({
        value: merchant.id,
        label: merchant.name,
        reserved: merchant.reserved,
      }));
      return dispatch({
        type: ACTION_TYPES.GET_MERCHANTS_SUCCESS,
        payload: {
          merchants: merchantData,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.GET_MERCHANTS_FAILURE,
    });
  }
};

export const createMerchant = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_MERCHANT_REQUEST,
  });
  try {
    const response = await postJSON(`/api/merchants`, values);
    if (response?.data) {
      toast.success("Merchant created!");
      dispatch({
        type: ACTION_TYPES.CREATE_MERCHANT_SUCCESS,
        payload: {
          newMerchant: response.data,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.CREATE_MERCHANT_FAILURE,
    });
  }
};

export const editMerchant = async (dispatch, merchantId, values) => {
  dispatch({
    type: ACTION_TYPES.EDIT_MERCHANT_REQUEST,
  });
  try {
    const response = await patchJSON(`/api/merchants/${merchantId}`, values);
    if (response?.data) {
      toast.success("Merchant updated!");
      dispatch({
        type: ACTION_TYPES.EDIT_MERCHANT_SUCCESS,
        payload: {
          updatedMerchant: response.data,
          merchantId,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.EDIT_MERCHANT_FAILURE,
    });
  }
};

export const deleteMerchant = async (dispatch, merchantId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_MERCHANT_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/merchants/${merchantId}`);
    if (response?.status === 204) {
      toast.success("Merchant deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_MERCHANT_SUCCESS,
        payload: {
          merchantId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_MERCHANT_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const getCategories = async (dispatch) => {
  dispatch({
    type: ACTION_TYPES.GET_CATEGORIES_REQUEST,
  });
  try {
    const response = await getJSON("/api/categories");
    if (response?.data) {
      const categoriesData = response.data.map((category) => ({
        label: category.name,
        id: category.id,
        reserved: category.reserved,
        isInvestment: category.is_investment,
        options: category.sub_categories?.map((s) => ({
          label: s.name,
          value: s.id,
          icon: s.icon,
          reserved: s.reserved,
          isInvestment: s.is_investment,
          tags: s.tags,
        })),
      }));
      return dispatch({
        type: ACTION_TYPES.GET_CATEGORIES_SUCCESS,
        payload: {
          categories: categoriesData,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.GET_CATEGORIES_FAILURE,
    });
  }
};

export const createSubCategory = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_SUB_CATEGORY_REQUEST,
  });
  try {
    const response = await postJSON(`/api/categories`, values);
    if (response?.data) {
      toast.success("Sub-category created!");
      return dispatch({
        type: ACTION_TYPES.CREATE_SUB_CATEGORY_SUCCESS,
        payload: {
          parentCategoryId: values.parent_id,
          newSubCategory: response.data,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.CREATE_SUB_CATEGORY_FAILURE,
    });
  }
};

export const createCategory = async (dispatch, values) => {
  dispatch({
    type: ACTION_TYPES.CREATE_CATEGORY_REQUEST,
  });
  try {
    const response = await postJSON(`/api/categories`, values);
    if (response?.data) {
      toast.success("Parent Category created!");
      dispatch({
        type: ACTION_TYPES.CREATE_CATEGORY_SUCCESS,
        payload: {
          newCategory: response.data,
        },
      });
      return response.data.id;
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.CREATE_CATEGORY_FAILURE,
    });
  }
};

export const editSubCategory = async (dispatch, subCategoryId, values) => {
  dispatch({
    type: ACTION_TYPES.EDIT_SUB_CATEGORY_REQUEST,
  });
  try {
    const response = await patchJSON(
      `/api/categories/${subCategoryId}`,
      values
    );
    if (response?.data) {
      toast.success("Sub-category updated!");
      return dispatch({
        type: ACTION_TYPES.EDIT_SUB_CATEGORY_SUCCESS,
        payload: {
          parentCategoryId: values?.category.parent_id,
          subCategoryId,
          updatedSubCategory: {
            label: response?.data?.name,
            value: response?.data?.id,
            icon: response?.data?.icon,
          },
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.EDIT_SUB_CATEGORY_FAILURE,
    });
    toast.error(error?.message || "Oops, update failed!");
  }
};

export const deleteIncomeCategory = async (dispatch, incomeId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_INCOME_CATEGORY_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/incomes/${incomeId}`);
    if (response?.status === 204) {
      toast.success("Income category deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_INCOME_CATEGORY_SUCCESS,
        payload: { incomeId },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_INCOME_CATEGORY_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const deleteParentCategory = async (dispatch, parentCategoryId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_PARENT_CATEGORY_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/categories/${parentCategoryId}`);
    if (response?.status === 204) {
      toast.success("Category deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_PARENT_CATEGORY_SUCCESS,
        payload: {
          parentCategoryId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_PARENT_CATEGORY_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const deleteSubCategory = async (
  dispatch,
  parentCategoryId,
  subCategoryId
) => {
  dispatch({
    type: ACTION_TYPES.DELETE_SUB_CATEGORY_REQUEST,
  });
  try {
    const response = await deleteJSON(`/api/categories/${subCategoryId}`);
    if (response?.status === 204) {
      toast.success("Sub-category deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_SUB_CATEGORY_SUCCESS,
        payload: {
          parentCategoryId,
          subCategoryId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_SUB_CATEGORY_FAILURE,
    });
    toast.error(error?.message || "Oops, delete failed!");
  }
};

export const removeIncomeCategoryTag = async (dispatch, incomeId, tagId) => {
  dispatch({
    type: ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_REQUEST,
    payload: { incomeId, tagId },
  });
  try {
    const response = await deleteJSON(
      `/api/incomes/${incomeId}/tags/${tagId}`
    );
    if (response?.status === 204) {
      toast.success("Tag deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_SUCCESS,
        payload: {
          incomeId,
          tagId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_INCOME_CATEGORY_TAG_FAILURE,
      payload: { incomeId, tagId },
    });
    toast.error(error?.message || "Oops, tag delete failed!");
  }
};

export const addSubCategoryTag = async (
  dispatch,
  parentCategoryId,
  subCategoryId,
  newTagName
) => {
  const tempId = `temp-${Date.now()}`;
  dispatch({
    type: ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_REQUEST,
    payload: { parentCategoryId, subCategoryId, newTagName, tempId },
  });
  try {
    const body = {
      name: newTagName,
    };
    const response = await postJSON(
      `/api/categories/${subCategoryId}/tags`,
      body
    );
    if (response?.data) {
      toast.success(`New "${newTagName}" tag saved!`);
      return dispatch({
        type: ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_SUCCESS,
        payload: {
          parentCategoryId,
          subCategoryId,
          newTag: response.data,
          tempId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.CREATE_SUB_CATEGORY_TAG_FAILURE,
      payload: { parentCategoryId, subCategoryId, tempId },
    });
    toast.error(error?.message || "Oops, tag creation failed!");
  }
};

export const removeSubCategoryTag = async (
  dispatch,
  parentCategoryId,
  subCategoryId,
  tagId
) => {
  dispatch({
    type: ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_REQUEST,
    payload: { parentCategoryId, subCategoryId, tagId },
  });
  try {
    const response = await deleteJSON(
      `/api/categories/${subCategoryId}/tags/${tagId}`
    );
    if (response?.status === 204) {
      toast.success("Tag deleted!");
      return dispatch({
        type: ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_SUCCESS,
        payload: {
          parentCategoryId,
          subCategoryId,
          tagId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ACTION_TYPES.DELETE_SUB_CATEGORY_TAG_FAILURE,
      payload: { parentCategoryId, subCategoryId, tagId },
    });
    toast.error(error?.message || "Oops, tag delete failed!");
  }
};

const CommonProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <CommonDispatchContext.Provider value={dispatch}>
      <CommonStateContext.Provider value={state}>
        {children}
      </CommonStateContext.Provider>
    </CommonDispatchContext.Provider>
  );
};

export default CommonProvider;
